import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import LoginPageKtherobot from "./components/pages/LoginKtherobot/LoginPage";
import LoginPageCardex from "./components/pages/LoginCardex/LoginPage";
import Menu from "./components/menu/Menu";
import ApplicationsPage from "./components/pages/Applications/ApplicationPage";
import ApplicationSettingsPage from "./components/pages/ApplicationSettings/ApplicationSettingsPage";
import UserManagementPage from "./components/pages/UserManagement/UserManagementPage";
import AdminsSummaryPage from "./components/pages/AdminsSummary/AdminsSummaryPage";
import DomainManagementPage from "./components/pages/DomainManagement/DomainManagementPage";
import AccessHistoryPage from "./components/pages/AccessHistory/AccessHistoryPage";
import IpBlockingPage from "./components/pages/IpBlocking/IpBlockingPage";
import UserPage from "./components/pages/user/userPage";
import MyDevicesPage from "./components/pages/MyDevices/MyDevicesPage";
import MyAccountPage from "./components/pages/MyAccount/MyAccountPage";
import ProDemandSourcePage from "./components/pages/ProDemandSource/ProDemandSourcePage";
import AllDataSourcePage from "./components/pages/AllDataSource/AllDataSourcePage";
import PrivateRoute from "./routes/PrivateRoute";
import LoginRedirect from "./routes/LoginRedirect";
import { getUser } from "./helpers/localStorage";
import LoginPageSmartCar from "./components/pages/LoginSmartCar/LoginPage";
const configSystem = require("./configApp");

export default function App() {
  return (
    <div>
      <Routes>
        <Route
          exact
          path="/"
          element={<Navigate to="/login" replace={true} />}
        />
        <Route
          path="/applications"
          element={
            <PrivateRoute>
              <Menu username={getUser().username}>
                <ApplicationsPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/applications-settings"
          element={
            <PrivateRoute
                        roles={[configSystem.roles.SUPER_ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.ADMIN]}
            >
              <Menu username={getUser().username}>
                <ApplicationSettingsPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/user-management"
          element={
            <PrivateRoute
                        roles={[configSystem.roles.SUPER_ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.ADMIN]}
            >
              <Menu username={getUser().username}>
                <UserManagementPage />
              </Menu>
            </PrivateRoute>
          }
        />
        {/* Resumen por administrador. Solo los roles que pueden ver a otros
            admins; un admin limitado no tiene a quien resumir. */}
        <Route
          path="/admins-summary"
          element={
            <PrivateRoute
              roles={[configSystem.roles.SUPER_ADMIN, configSystem.roles.SUPER_USER]}
            >
              <Menu username={getUser().username}>
                <AdminsSummaryPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/domain-management"
          element={
            <PrivateRoute
                        roles={[configSystem.roles.SUPER_ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.ADMIN]}
            >
              <Menu username={getUser().username}>
                <DomainManagementPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/access-history"
          element={
            <PrivateRoute
                        roles={[configSystem.roles.SUPER_ADMIN, configSystem.roles.SUPER_USER, configSystem.roles.ADMIN]}
            >
              <Menu username={getUser().username}>
                <AccessHistoryPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/ip-blocking"
          element={
            <PrivateRoute
                        roles={[configSystem.roles.SUPER_ADMIN]}
            >
              <Menu username={getUser().username}>
                <IpBlockingPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/login"
          element={
            <LoginRedirect>
              {process.env.REACT_APP_REFERENCE_APP === "ktherobot" ? (
                <LoginPageKtherobot />
              ) : process.env.REACT_APP_REFERENCE_APP === "carsmart" ? (
                <LoginPageSmartCar />) : 
              (
                <LoginPageCardex />
              )}
            </LoginRedirect>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <Menu username={getUser().username}>
                <UserPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/my-devices"
          element={
            <PrivateRoute>
              <Menu username={getUser().username}>
                <MyDevicesPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/my-account"
          element={
            <PrivateRoute>
              <Menu username={getUser().username}>
                <MyAccountPage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/prodemand-source"
          element={
            <PrivateRoute>
              <Menu username={getUser().username}>
                <ProDemandSourcePage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route
          path="/alldata-source"
          element={
            <PrivateRoute>
              <Menu username={getUser().username}>
                <AllDataSourcePage />
              </Menu>
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace={true} />} />
      </Routes>
    </div>
  );
}
